<template>
  <div class="pa-4">
    <v-alert v-if="isCnpjInactive" type="error" dense class="mb-4">
      <strong>Edição bloqueada:</strong> CNPJ em situação irregular na Receita Federal. Não é possível realizar alterações.
    </v-alert>
    
    <div class="d-flex justify-space-between">
      <p class="text-h6 font-weight-bold">Portfólio de mídia</p>

      <div class="d-flex align-center" style="height: 30px">
        <div class="mr-6">
          <span class="text-blue font-weight-bold">{{ allInventories }}</span> Inventário(s) |
          <span class="text-blue font-weight-bold">{{ allASUSsActivated }}</span> Formato(s) ativo(s)
        </div>
        <v-btn to="/app/inventory/formats" text>
          Gerenciar Inventário(s)
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>

    <v-data-table :headers="headers" :items="inventoriesList" :loading="loadingInventoriesData" :items-per-page="5"
      class="elevation-1">

      <template v-slot:[`item.headerIndex`]="{ index }">
        <div class="text-center">{{ index + 1 }}</div>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <div class="d-flex justify-center">
          <v-chip :color="item?.status === 'published' ? 'green' : 'red'" text-color="white" small>
            <strong>{{ item?.status === 'published' ? 'Ativa' : 'Inativa' }}</strong>
          </v-chip>
        </div>
      </template>

      <template v-slot:[`item.master`]="{ item }">
        <div class="text-center">
          <span v-if="item.master != null">{{ item.master }}</span>
          <span v-else>-</span>
        </div>
      </template>

      <template v-slot:[`item.logo`]="{ item }">
        <div class="d-flex justify-center">
          <v-img :lazy-src="item.logo" max-height="41" max-width="41" :src="item.logo"></v-img>
        </div>
      </template>

      <template v-slot:[`item.display_name`]="{ item }">
        <div class="text-center">{{ item.display_name }}</div>
      </template>

      <template v-slot:[`item.activatedAsus`]="{ item }">
        <div class="text-center">{{ item.activatedAsus }}</div>
      </template>

      <template v-slot:[`item.asus`]="{ item }">
        <div class="text-center">{{ item.asus }}</div>
      </template>

      <template v-slot:[`item.create_date`]="{ item }">
        <div class="text-center">{{ item.create_date != null ? item.create_date : '-' }}</div>
      </template>

      <template v-slot:[`item.updated_on`]="{ item }">
        <div class="text-center">{{ item.updated_on != null ? item.updated_on : '-' }}</div>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div class="text-center">
          <v-btn :to="`/app/inventory/formats?inventory=${encodeURIComponent(item.display_name)}`" icon small>
            <v-icon color="primary">
              mdi-arrow-right
            </v-icon>
          </v-btn>
        </div>
      </template>

    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "InventoryProfile",

  props: {
    profileId: {
      type: [String, Number],
      required: true,
    },
    isCnpjInactive: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    allInventories() {
      return this.inventoriesList.length
    },

    allASUSsActivated() {
      let countASUs = 0

      this.inventoriesList.map(inventory => {
        countASUs += inventory.activatedAsus
      })

      return countASUs
    }
  },

  async created() {
    await this.loadInventoriesData();
  },

  data() {
    return {
      inventoriesList: [],
      loadingInventoriesData: false,
      headers: [
        {
          text: "#",
          value: "headerIndex",
          align: "center",
        },
        {
          text: "Logo",
          value: "logo",
          align: "center",
        },
        {
          text: "Nome",
          value: "display_name",
          align: "center",
        },
        {
          text: "Master",
          value: "master",
          align: "center",
        },
        {
          text: "Status Inventário",
          value: "status",
          align: "center",
        },
        {
          text: "Formatos Ativos",
          value: "activatedAsus",
          align: "center",
        },
        {
          text: "Formatos Cadastrados",
          value: "asus",
          align: "center",
        },
        {
          text: "Data de Criação",
          value: "create_date",
          align: "center",
        },
        {
          text: "Data de Edição",
          value: "updated_on",
          align: "center",
        },
        {
          text: "",
          value: "action",
          sortable: false,
          width: "60px",
          align: "center",
        },
      ],
    };
  },

  methods: {
    async loadInventoriesData() {
      try {
        this.loadingInventoriesData = true;

        const response = await this.$axios.get(`editor/inventories?profileId=${this.profileId}`);

        if (response.data && response.data.data) {
          this.inventoriesList = response.data.data;
        }
      } catch (error) {
        console.error('Erro ao carregar inventários:', error);
      } finally {
        this.loadingInventoriesData = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: 'Roboto', sans-serif !important;
}

.text-blue {
  color: #233a75;
}
</style>